// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","accent":"#BFD730","primary":"#492172","outer":"_3oeq","title":"_3qhA","body":"_3u17"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/MultiText/MultiTextParagraphs/MultiTextParagraphs.scss
// module id = jS/O
// module chunks = 0